/* eslint-disable no-else-return */
/* eslint-disable no-nested-ternary */
import React, { useState } from "react";
import styled from "styled-components";
import momentTimezone from 'moment-timezone';
import { useEffect } from "react";
import { request } from '../../shared/utils/Api';
import AffectedComponents from "./AffectedComps";
import { RecentIncidentUpdate } from "./IncidentUpdatesList";
import { getComponentsByGroup } from "../../shared/utils";
import { messageWithLinks } from "../../shared/utils/text";
import { CardWrapper, IncidentContainer, DescriptionContainer } from "./style";
import { useMediaQuery } from "@mui/material";

function IncidentCard(props) {
  const { incidentClass, incidentDetails, componentGroups, size, accountId } = props;
  // const { title, manageSubscriber = true } = branding_data;
  const [incidentUpdates, setincidentUpdates] = useState([]);
  const [lastupdated, setlastupdated] = useState(null);
  const isMobile = useMediaQuery("(max-width: 992px)");
  const { description, affected_components_filtered } = incidentDetails;

  const componentsByGroup = getComponentsByGroup(
    affected_components_filtered,
    props.components
  );

  useEffect(() => {
    if (incidentClass) {
      getIncidentUpdates(incidentDetails.id, accountId);
    }
  }, [incidentDetails, accountId, incidentClass]);

  const getTextColor = () => {
    if (componentsByGroup && Object.values(componentsByGroup).length) {
      const statusArr = [];
      Object.values(componentsByGroup).map((a) => {
        statusArr.push(...a);
      });
      const tempArr = statusArr.map((a) => a.status);
      if (tempArr.length && tempArr.indexOf("MO") > -1) return "major_outage";
      if (tempArr.length && tempArr.indexOf("PO") > -1) return "partial_outage";
      if (tempArr.length && tempArr.indexOf("PD") > -1)
        return "degraded_performance";
      if (tempArr.length && tempArr.find((a) => a === "operational"))
        return "operational";

      return "default";
    }
  };
  const getDisplayTime = (time) => {
    const mins = momentTimezone
      .tz(new Date(time), props.timezone)
      .format('MMM DD, hh:mm A');
    return mins;
  };

  const getIncidentUpdates = async (incidentID) => {
    await request(
      `/public-incident-updates/?account_id=${accountId}&incident=${incidentID}&ordering=display_time`
    ).then((data) => {
      const list = data?.results?.filter((a) => a.message) ?? [];
      const fallbackUpdates = data?.incident_updates;
      const lastUpdate = list?.length
        ? list[list.length - 1]
        : fallbackUpdates?.length
          ? fallbackUpdates[fallbackUpdates.length - 1]
          : null;
      const temp = lastUpdate ? getDisplayTime(lastUpdate.updated_at) : null;
      setlastupdated(temp);
      setincidentUpdates(list);
    });
  };

  const titlecolor = getTextColor();
  return (
    <CardWrapper
      display="flex"
      alignItems="flex-end"
      justifyContent="space-between"
      // onClick={() => Router.push(`/incidents/${id}`)}
      className={[incidentClass, "incidentWrapperClass"]}
      statusType={titlecolor}
    >
      <IncidentContainer
        statusType={titlecolor || "MO"}
        isAffected={!!componentsByGroup}
      >
        <div className="incident-title">
          {/* href={`/incidents/${id}`} */}
          {/* <Link > */}
          <a className={titlecolor}>
            <div className="incidentTitle">{incidentDetails.title}</div>
          </a>
          {/* </Link> */}
        </div>
        {incidentUpdates && incidentUpdates.length ? (
          <RecentIncidentUpdate incidentUpdates={incidentUpdates} />
        ) : (
          <DescriptionContainer size={size}><span className="message">{messageWithLinks(description)}</span></DescriptionContainer>
        )}
      </IncidentContainer>
      {/* {!isMobile ? (
        <AffectedComponents
          collapsible={false}
          limitInfo={5}
          componentsByGroup={componentsByGroup}
          componentGroups={componentGroups}
          productName={props.productName}
        />
      ) : (
        ""
      )} */}
    </CardWrapper>
  );
}

export default IncidentCard;
